<template>

  <div class="container">
    <p class="text">{{ label[language] }}</p>
  </div>

</template>

<script>
export default {
  name: 'InvalidPage',

  data() {
    return {
      label: {
        zh_TW: '此單號已過期',
        en_US: '"This order number has expired."',
      },
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
  },
  watch: {
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-self: center;
  align-items: center;
}

.text {
  width: 100%;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
}
</style>
